module.exports = {"slides":["Fact1","Fact2","Fact3","Fact4","Fact5","Fact6"]}


//////////////////
// WEBPACK FOOTER
// ./src/components/SlideFragment/config.json
// module id = 78
// module chunks = 0